import React, {useState} from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {useAuthConfig} from "./helper";
import { getOptionSelectedByField } from './utils/autocompleteUtils';

export default function FindOtherSupplierSelect({onContentChange}) {
    let authAxios = useAuthConfig();
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const getSuppliersList = async (value) => {
        setLoading(true)
        try {
            await authAxios.get(`/suppliers?queryString=${value}`).then(res => {
                setOptions(res.data)
                setLoading(false)
            })
        } catch (e) {
            console.error(e);
            setLoading(false)
        }
    };
    const handleValueChange = (value) => {
        onContentChange(value)
    }
    return (
        <Autocomplete
            fullWidth
            id="supplier-find"
            options={options}
            getOptionLabel={(option) => `${option.supplierName} - ${parseInt(option.supplierNumber)}` }
            getOptionSelected={getOptionSelectedByField('supplierNumber')}
            loading={loading}
            onChange={(e, value) => {
                handleValueChange(value)
            }}
            onInputChange={(e, value) => {
                if(value.length > 2)
                    getSuppliersList(value)
            }}
            renderInput={(params) => <TextField {...params} placeholder="Search Supplier name or number (enter 3 or more characters)" variant="outlined" />}
        />
    );
}
